var NF_SaveProgress = Marionette.Application.extend({

    initialize: function( options ){

        // Load Controllers.
        new nfSaveProgressActiveController();
        new nfSaveProgressSaveButtonController();
        new nfSaveProgressPassiveController();

        Backbone.Radio.channel( 'forms' ).reply( 'save:fieldAttributes', this.getfieldAttributes, this );
        Backbone.Radio.channel( 'forms' ).reply( 'save:updateFieldsCollection', this.updateFieldsCollection, this );
    },

    getfieldAttributes: function( formID ) {
        var formModel = Backbone.Radio.channel( 'app' ).request( 'get:form', formID );

        var fields = formModel.get( 'fields' ).filter( function( fieldModel, key ){
            if ( 'html' == fieldModel.get( 'type' ) ) return false;
            // If we don't have a value...
            // AND our field is anything other than a table editor...
            if ( ! fieldModel.get( 'value' ) && 'table_editor' != fieldModel.get( 'type' ) ) return false;
            // If the model is clean...
            // AND it has a type of anything other than file upload or table editor...
            // AND it's not a date field with time values set (changeHoursMinutes doesn't set clean:false)
            if ( fieldModel.get( 'clean' ) && 'file_upload' != fieldModel.get( 'type' ) && 'table_editor' != fieldModel.get( 'type' ) ) {
                // Exception: Date fields with selected_hour are modified even if marked clean
                // This works around core NF not setting clean:false in changeHoursMinutes
                if ( 'date' == fieldModel.get( 'type' ) && fieldModel.get( 'selected_hour' ) ) {
                    return true; // Keep this field
                }
                return false;
            }
            return true;
        });

        var omit = [
            /* core */ 'admin_label', 'element_class', 'required', 'container_class', 'custom_mask','mask', 'manual_key', 'drawerDisabled', 'input_limit', 'input_limit_msg', 'input_limit_type', 'help_text', 'desc_text', 'created_at', 'editActive', 'disabled', 'afterField', 'beforeField', 'classes', 'confirm_field', 'element_templates', 'errors', 'formID', 'key', 'label', 'label_pos', 'mirror_field', 'objectDomain', 'objectType', 'old_classname', 'order', 'parentType', 'placeholder', 'reRender', 'type', 'wrap_template',
            /* List Fields */ 'options',
            /* Table Editor */ 'hot', 'tableConfig',
            /* File Uploads */ 'uploadNonce', 'upload_types',
            /* Layout & Styles */ 'cellcid',
            /* Date/Time Fields - these are PHP-generated HTML that should not be saved/restored */
            'hours_options', 'minutes_options'
        ];

        // Attributes to be saved.
        var atts = fields.map( function( fieldModel, key ) {
            return _.omit( fieldModel.attributes, function( value, key, object ){

                // Omit function properties.
                if( 'function' == typeof value ) return true;

                // Omit known "non-essential" core attributes.
                if( -1 !== omit.indexOf( key ) ) return true;

                // Omit Layout & Styles attributes.
                if( -1 !== key.indexOf( '_styles_' ) ) return true;
               return false;
            });
        });
        return atts;
    },

    updateFieldsCollection: function( formInstanceID, savedFields ){
        var formModel = Backbone.Radio.channel( 'app' ).request( 'get:form', formInstanceID );
        var fieldsCollection = formModel.get( 'fields' );

        var instanceID = formInstanceID.toString().split('_')[1];

        // Preserve hours_options/minutes_options from date fields before reset.
        // These are PHP-generated HTML strings that would be lost during collection reset.
        var dateFieldOptions = {};
        fieldsCollection.each(function(field) {
            if (field.get('type') === 'date') {
                var fieldId = field.get('id');
                dateFieldOptions[fieldId] = {
                    hours_options: field.get('hours_options'),
                    minutes_options: field.get('minutes_options')
                };
            }
        });

        var defaults = formModel.get( 'loadedFields' );
        fieldsCollection.reset( defaults );

        // Restore hours_options/minutes_options to date fields after reset
        _.each(dateFieldOptions, function(options, fieldId) {
            var field = fieldsCollection.get(fieldId);
            if (field && options.hours_options) {
                field.set('hours_options', options.hours_options, { silent: true });
                field.set('minutes_options', options.minutes_options, { silent: true });
            }
        });

        _.each( savedFields, function( savedField ){
            var fieldID = parseInt( savedField.id );

            if('undefined' !== typeof instanceID){
                fieldID += '_' + instanceID;
            }

            var field   = fieldsCollection.get( fieldID );
            var atts    = _.omit( savedField, [
                /* Core */ 'id', 'required',
                /* File Uploads */ 'uploadNonce', 'upload_types',
                /* Date/Time - preserve PHP-generated HTML, don't restore saved versions */
                'hours_options', 'minutes_options'
            ] );

            // Force `visible` attribute to a String
            if( 'undefined' != typeof atts.visible ) {
                atts.visible = atts.visible.toString();
            }

            if( 'undefined' != typeof field ) {
                var fieldType = field.get('type');
                var dateMode = field.get('date_mode');
                var isDateField = fieldType === 'date';
                var hasTimeComponent = dateMode && dateMode !== 'date_only';

                field.set(atts);

                // For date fields with time components, do NOT reRender - it destroys the
                // hours_options/minutes_options that were pre-rendered from PHP.
                // Instead, we update the DOM selects directly below.
                if (!(isDateField && hasTimeComponent)) {
                    field.trigger('reRender');
                }

                // Update time select values directly in the DOM for date fields with time components
                var hasValue = atts.value || atts.selected_hour;
                if (isDateField && hasTimeComponent && hasValue) {
                    var baseFieldID = parseInt(savedField.id);
                    var container = jQuery('#nf-field-' + baseFieldID + '-container');

                    if (container.length) {
                        var hour = atts.selected_hour;
                        var minute = atts.selected_minute;
                        var ampm = atts.selected_ampm;

                        // Parse from value if selected_hour not available
                        if (!hour && atts.value) {
                            var timeParts = atts.value.match(/(\d{1,2}):(\d{2})(?:\s*(am|pm))?/i);
                            if (timeParts) {
                                hour = timeParts[1];
                                minute = timeParts[2];
                                ampm = timeParts[3];
                            }
                        }

                        if (hour && minute) {
                            var hourSelect = container.find('select.hour');
                            var minuteSelect = container.find('select.minute');

                            if (hourSelect.length && minuteSelect.length) {
                                hourSelect.val(String(hour));
                                minuteSelect.val(String(minute));
                                hourSelect.trigger('change');
                                minuteSelect.trigger('change');

                                if (ampm) {
                                    var ampmSelect = container.find('select.ampm');
                                    if (ampmSelect.length) {
                                        ampmSelect.val(ampm.toLowerCase());
                                        ampmSelect.trigger('change');
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });

        Backbone.Radio.channel( 'fields' ).trigger( 'reset:collection', fieldsCollection );
    }
});
